import login from '../../assets/images/image-signin.png'
import Form from "../../components/common/Form";
import listInput from './const'
import { FC } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router'
import React from 'react'
import { CircularProgress, CssBaseline, Grid, Typography } from '@mui/material';
import { fetchLoginAccountRequest } from '@redux/Accounts/actions';
import Toast from '@components/common/Toast/toast';

const Login: FC = function () {
// export default function Login(){
    const dispatch = useDispatch<any>()
    const navigate = useNavigate()
    const email = new URLSearchParams(window.location.search).get('email')
    const code = new URLSearchParams(window.location.search).get('code')
    
    const onLogin = (value: any) => {
        const callback = () => {
            navigate("/");
        };
        dispatch(fetchLoginAccountRequest(value, callback));
    };

    if (code) return (
        <Grid container direction='row' alignItems='center' justifyContent='center' spacing={2} style={{ position: 'fixed', top: '50vh', transform: 'translateY(-50%)' }}>
            <CssBaseline />
            <Grid item>
                <Grid
                    container
                    alignItems="center"
                    justifyContent="center"
                >
                    <CircularProgress />
                </Grid>
            </Grid>
            <Grid item>
                <Typography>Đang kết nối...</Typography>
            </Grid>
        </Grid>
    )

    return (
        <>
            <Form
                initValue={{
                    email: email
                }}
                image={login}
                title='Đăng nhập'
                // social={{
                //     onGoogle
                // }}
                des='Bạn chưa có tài khoản ?'
                listInput={listInput}
                buttonText="Đăng nhập"
                forgotAction="Quên mật khẩu ?"
                disableOr={false}
                onSubmit={onLogin}
                subAction={[
                    {
                        nav: '/signup',
                        title: 'Đăng ký'
                    }

                    // {
                    //     nav: '/forgot-password',
                    //     title: 'Quên mật khẩu ?'
                    // }
                ]}
            />
            <Toast/>
        
        </>
    )
}

export default Login
